import React from 'react';
import { ProgressBar as BootstrapProgressBar } from 'react-bootstrap';  // <-- переименовали
import { GROUP_ORDER, STAGE_GROUPS, getGroupProgress, isGroupUnlocked } from '../auth/roles';
import { formatDate } from '../utils/date';

export function progressLevel(value) {
  if (value >= 80) return 'high';
  if (value >= 40) return 'mid';
  return 'low';
}

// Это ваша кастомная функция ProgressBar – оставляем как есть
export function ProgressBar({ value = 0, size = 'sm', showLabel = false, className = '' }) {
  const pct = Math.min(100, Math.max(0, value));
  const level = progressLevel(pct);
  return (
    <div className={className}>
      {showLabel && (
        <div className="d-flex justify-content-between mb-1">
          <span className="app-text-muted small">Прогресс</span>
          <strong className="small">{pct}%</strong>
        </div>
      )}
      <div className={`app-progress ${size === 'sm' ? 'app-progress-sm' : ''}`}>
        <div className={`app-progress-bar ${level}`} style={{ width: `${pct}%` }} />
      </div>
    </div>
  );
}

export const QuantityProgress = ({ done, total, label = 'из' }) => {
  const doneNum = Number(done) || 0;
  const totalNum = Number(total) || 0;
  const percent = totalNum > 0 ? Math.min(100, Math.round((doneNum / totalNum) * 100)) : 0;

  const text = totalNum > 0 ? `${doneNum} ${label} ${totalNum}` : `${doneNum}`;

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-1">
        <span className="app-text-muted small">{text}</span>
      </div>
      <BootstrapProgressBar
        now={percent}
        label={false}
        className="app-progress"
        style={{ height: '6px' }}
      />
    </div>
  );
};

export function DeadlineBadge({ deadline, isOverdue }) {
  if (!deadline) return null;
  const formatted = formatDate(deadline);
  return (
    <span className={`app-badge ${isOverdue ? 'app-badge-danger priority-overdue' : 'app-badge-neutral'}`}>
      {isOverdue ? '⚠ Просрочено: ' : 'Срок: '}{formatted}
    </span>
  );
}

export function StageBadge({ stage }) {
  if (!stage) return <span className="app-badge app-badge-success">Завершён</span>;
  return <span className="app-badge app-badge-brand">{stage.stage_type_display || stage.stage_group_display}</span>;
}

export function PageHeader({ title, subtitle, actions, backLink }) {
  return (
    <div className="page-header">
      <div className="d-flex align-items-start justify-content-between flex-wrap gap-2">
        <div>
          {backLink}
          <h1>{title}</h1>
          {subtitle && <p>{subtitle}</p>}
        </div>
        {actions && <div className="d-flex gap-2 flex-wrap">{actions}</div>}
      </div>
    </div>
  );
}

export function HistoryTimeline({ items = [] }) {
  if (!items.length) {
    return <div className="empty-state small">История действий пуста</div>;
  }
  return (
    <ul className="history-list">
      {items.map((item) => (
        <li key={item.id} className="history-item">
          <span className="history-dot" />
          <div>
            <div>{item.action}</div>
            <div className="app-text-muted" style={{ fontSize: 12 }}>
              {item.user_name || 'Система'} · {formatDate(item.created_at)}
            </div>
          </div>
        </li>
      ))}
    </ul>
  );
}

export function StagePipeline({ grouped, activeGroup, onSelectGroup }) {
  return (
    <div className="stage-pipeline-wrapper">
      <div className="stage-pipeline">
        {GROUP_ORDER.map((group, idx) => {
          const stages = grouped[group] || [];
          const progress = getGroupProgress(stages);
          const unlocked = isGroupUnlocked(grouped, group);
          const isActive = group === activeGroup;
          const isDone = progress === 100;

          return (
            <div
              key={group}
              className={`stage-segment ${isActive ? 'active' : ''} ${isDone ? 'done' : ''} ${!unlocked && !isDone ? 'locked' : ''}`}
              style={{ flex: 1 }}
              onClick={() => onSelectGroup(group)}
            >
              <div className="stage-segment-content">
                <span className="stage-segment-icon">{STAGE_GROUPS[group]?.icon}</span>
                <span className="stage-segment-label">{STAGE_GROUPS[group]?.label}</span>
                <span className="stage-segment-pct">{progress}%</span>
              </div>
              <div className="stage-segment-bar">
                <div className="stage-segment-fill" style={{ width: `${progress}%` }} />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}